import teriyaki from './teriyakiHero.png';
import chopped from './choppedHero.jpg';

//key name must be same as appSource.

export default {
  teriyaki,
  chopped,
};
